import PropTypes from 'prop-types';
import React from 'react';
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
  Font,
  PDFViewer,
  Note,
  Layp,
  BlobProvider,
  pdf
} from '@react-pdf/renderer';
import {
  Container,
  Box,
  Stack,
  Typography,
  TextField,
  Divider,
  Button,
  Switch,
  FormGroup,
  FormControlLabel,
  alpha
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { sentenceCase } from 'change-case';
import uploadFill from '@iconify/icons-eva/upload-fill';
import folderAddFill from '@iconify/icons-eva/folder-add-fill';
import downloadOutline from '@iconify/icons-eva/download-outline';
import { Icon } from '@iconify/react';
import hardDriveFilled from '@iconify/icons-eva/hard-drive-fill';
import arrowBackFilled from '@iconify/icons-eva/arrow-back-fill';
import closeCircleFill from '@iconify/icons-eva/close-circle-fill';
import shareOutline from '@iconify/icons-eva/share-outline';
import checkmarkCircleFill from '@iconify/icons-eva/checkmark-circle-fill';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import _ from 'lodash';
import moment from 'moment-timezone';
import moment_ from 'moment';
import 'moment/min/locales';
import jwt, { decode } from 'jsonwebtoken';
import { useTheme, styled } from '@mui/material/styles';
//
import indexFinder from '../utils/indexFinder';
import '../fonts/ngayogyan/ngayogyan-indo.ttf';
import BookosRegular from '../fonts/bookos-regular.ttf';
import BookosBold from '../fonts/bookos-bold.ttf';
import BookosItalic from '../fonts/bookos-italic.ttf';
import BookosBolditalic from '../fonts/bookos-bold-italic.ttf';
// Components
import Header from '../components/_landingpage/LandingHeader';
import QRGenerator from '../components/QRGenerator';
// Services
import * as myLayananService from '../services/mylayanan';
import * as permohonanService from '../services/permohonan';
import * as kategoriseService from '../services/kategorise';
import * as feedbackService from '../services/feedback';
import * as shortlinkService from '../services/shortlink';
import encryptor from '../utils/encryptor';
import { getBaseURL, getAPIURL } from '../utils/envGetter';
import * as attachmentService from '../services/attachment';
import PDFRendererForTTE from './PDFRendererForTTE';
import errorLogger from '../utils/errorLogger';
import PDFRendererForAduan from './PDFRendererForAduan';
import PDFRendererForVideotron from './PDFRendererForVideotron';
import PDFRendererForGeneral from './PDFRendererForGeneral';
import PDFRendererForVPN from './PDFRendererForVPN';
import PDFRendererForBackup from './PDFRendererForBackup';
import PDFRendererForEmail from './PDFRendererForEmail';
// ----------------------------------------------------------------------

const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    paddingBottom: '2.5cm'
  },
  pageWithPaddingTop: {
    flexDirection: 'column',
    paddingTop: '2cm',
    paddingBottom: '2.5cm'
  },
  pageWaterMarked: {
    flexDirection: 'column',
    paddingBottom: '2.5cm'
  },
  pageWithPaddingTopWaterMarked: {
    flexDirection: 'column',
    paddingTop: '2cm',
    paddingBottom: '2.5cm'
  },
  watermarked: {
    transform: 'rotate(-35deg)',
    zIndex: 1,
    position: 'absolute',
    marginLeft: '25%',
    marginTop: '50%'
  },
  section: {
    marginBottom: 5,
    flexGrow: 1
  },
  subSection: {
    marginBottom: 5,
    flexGrow: 1
  },
  textRegular: {
    fontSize: 9,
    fontFamily: 'Bookos',
    fontWeight: 'normal',
    color: '#424242'
  },
  textBold: {
    fontSize: 10,
    fontFamily: 'Bookos',
    fontWeight: 'bold',
    color: '#424242'
  },
  textTitle: {
    fontSize: 11,
    fontFamily: 'Bookos',
    fontWeight: 'black',
    color: '#424242'
  }
});

//
PDFPage.propTypes = {
  user: PropTypes.object.isRequired
};

function getTitle(id) {
  if (id === 'subdomain') return 'Formulir Permohonan Subdomain Hosting';
  if (id === 'hosting') return 'Formulir Permohonan Hosting';
  if (id === 'kategori_se') return 'Formulir Permohonan Kategori Sistem Elektronik';
  if (id === 'feedback') return 'Rekomendasi';
  if (id === 'rekomendasi') return 'Permohonan Rekomendasi';
  if (id === 'tte') return 'Rekomendasi Penerbitan Sertifikat Elektronik';
  if (id === 'aduan') return 'Permohonan Aduan';
  if (id === 'videotron') return 'Permohonan Penayangan Konten Videotron';
  if (id === 'splp') return 'Permohonan Pemanfaatan SPLP';
  if (id === 'cloud') return 'Permohonan \nCloud Storage';
  if (id === 'backup') return 'Formulir Permintaan Backup Data';
  if (id === 'vpn') return 'Permohonan VPN';
  if (id === 'email') return 'Permohonan \nEmail Jogjaprov';
  if (id === 'web') return 'Permohonan \nTemplate Website';
  return 'Permohonan';
}

const EXCLUDED_ANSWER_IDS = ['jenis_tte'];

export default function PDFPage({ user }) {
  const { id, token } = useParams();
  const decoded = jwt.decode(token);

  const [layanan, setLayanan] = React.useState({});
  const [informations, setInformations] = React.useState([]);
  const [signer, setSigner] = React.useState({
    signername: '',
    nip: '',
    passphrase: '',
    nik: ''
  });

  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [openPreview, setOpenPreview] = React.useState(true);
  const [attachment, setAttachment] = React.useState('');

  const getLayanan = async () => {
    try {
      if (!id) return;
      const result = await myLayananService.getLayananByID(id);
      setLayanan(result.data);
      setOpenPreview(true);
      setIsSubmitting(false);
    } catch (error) {
      toast.error(error.message);
    }
  };

  const updateInformations = () => {
    if (_.isEmpty(layanan)) return;

    let questions = '';
    let answers = '';
    let dataDukung = '';
    const data = [];

    const requirements = layanan.meta?.data_permohonan?.JenisPermohonan?.metadata?.requirements;
    const requirementIndex = indexFinder(requirements, decoded.selectedRequirement.type, 'type');

    questions = requirements[requirementIndex]?.meta?.questions;

    if (decoded.selectedRequirement.type === 'data_permohonan') {
      answers = layanan?.meta?.data_permohonan?.metadata?.answers;
      if (!_.isEmpty(questions) && !_.isEmpty(answers)) {
        questions.forEach((question) => {
          if (!EXCLUDED_ANSWER_IDS.includes(question.id))
            data.push({ id: question.id, label: question.label, answer: answers[question.id] });
        });
      }
    }

    if (decoded.selectedRequirement.type === 'kategori_se') {
      answers = layanan?.meta?.kategori_se?.metadata?.answers;
      dataDukung = layanan?.meta?.kategori_se?.metadata?.data_dukung;
      if (!_.isEmpty(questions) && !_.isEmpty(answers)) {
        questions.forEach((question) => {
          data.push({
            id: question.id,
            label: question.label,
            options: question.options,
            answer: answers[question.id],
            data_dukung: dataDukung[question.id]
          });
        });
      }
    }

    if (decoded.selectedRequirement.type === 'feedback') {
      answers = layanan?.meta?.feedback?.metadata?.answers;
      if (!_.isEmpty(questions) && !_.isEmpty(answers)) {
        questions.forEach((question) => {
          data.push({ id: question.id, label: question.label, answer: answers[question.id] });
        });
      }
    }

    let signerName = layanan?.meta?.data_permohonan?.metadata?.answers?.nama_kepala_dinas;
    let signerNip = layanan?.meta?.data_permohonan?.metadata?.answers?.nip_kepala_dinas;
    const signerDinas = layanan?.meta?.data_permohonan?.metadata?.answers?.nama_perangkat_daerah;

    if (decoded.selectedRequirement.type === 'feedback') {
      signerName = '';
      signerNip = '';
    }

    setSigner({ signername: signerName, nip: signerNip, signerDinas, passphrase: '', nik: '' });

    setInformations(data);
  };

  React.useEffect(() => {
    updateInformations();
  }, [layanan]);

  React.useEffect(() => {
    getLayanan();
  }, [id]);

  // END USE EFFECT

  const signDocument = async () => {
    if (!signer.nik) return toast.error('Maaf, NIK belum diisi');
    if (!signer.passphrase) return toast.error('Maaf, Passphrase TTE belum diisi');

    const element = (
      <PDFDocument
        informations={informations}
        decoded={decoded}
        layanan={layanan}
        preview={false}
      />
    );
    const pdfDoc = pdf();
    pdfDoc.updateContainer(element);
    const blob = await pdfDoc.toBlob();

    if (!blob) return toast.error('Maaf, gagal mengambil dokumen');

    setIsSubmitting(true);

    const formData = new FormData();
    const file = new File([blob], layanan?.id, { lastModified: new Date().getTime() });

    const signers = [];
    const signerData = signer;
    signerData.passphrase = encryptor(signerData.passphrase);
    signers.push(signerData); // array to handle multiple page posibility

    formData.append('file', file);
    formData.append('upload_type', 'blob');
    formData.append('signer_meta_data', JSON.stringify(signers));

    if (decoded.selectedRequirement.type === 'data_permohonan') {
      const id = layanan?.attributes?.id_permohonan;
      const origin = getBaseURL();
      const linkQR = `${origin}/pdfscan?id=${id}`;
      formData.append('id_permohonan', id);
      formData.append('link_qr', linkQR);
      formData.append('user_info', JSON.stringify(user));
      formData.append('type', layanan?.type);

      toast
        .promise(permohonanService.signDocument(formData), {
          loading: 'Mohon tunggu ...',
          error: <b>Maaf, terjadi kesalahan. Cek kembali passphrase atau koneksi internet Anda.</b>,
          success: <b>Dokumen berhasil ditandatangani</b>
        })
        .then(() => {
          // setIsSaved(true);
          setSigner({ ...signer, passphrase: '' });
          getLayanan();
          setIsSubmitting(false);
        })
        .catch((error) => {
          setIsSubmitting(false);
          setSigner({ ...signer, passphrase: '' });
          errorLogger(error);
        });
    }

    if (decoded.selectedRequirement.type === 'kategori_se') {
      const id = layanan?.attributes?.id_kategorisasi_se;
      const origin = getBaseURL();
      const linkQR = `${origin}/pdfscan?id=${id}`;
      formData.append('id_kategorisasi_se', id);
      formData.append('link_qr', linkQR);
      formData.append('user_info', JSON.stringify(user));
      formData.append('type', 'Kategori Sistem Elektronik');

      toast
        .promise(kategoriseService.signDocument(formData), {
          loading: 'Mohon tunggu ...',
          error: <b>Maaf, terjadi kesalahan. Cek kembali passphrase atau koneksi internet Anda.</b>,
          success: <b>Dokumen berhasil ditandatangani</b>
        })
        .then(() => {
          // setIsSaved(true);
          setSigner({ ...signer, passphrase: '' });
          getLayanan();
        })
        .catch((error) => {
          setIsSubmitting(false);
          setSigner({ ...signer, passphrase: '' });
          errorLogger(error);
        });
    }

    if (decoded.selectedRequirement.type === 'feedback') {
      setIsSubmitting(false);
      const id = layanan?.attributes?.id_feedback;
      const origin = getBaseURL();
      const linkQR = `${origin}/pdfscan?id=${id}`;
      formData.append('id_feedback', id);
      formData.append('link_qr', linkQR);
      formData.append('status', layanan?.meta?.feedback?.metadata?.answers?.status);
      formData.append('type', layanan?.type);
      formData.append('user_info', JSON.stringify(user));

      toast
        .promise(feedbackService.signDocument(formData), {
          loading: 'Mohon tunggu ...',
          error: <b>Maaf, terjadi kesalahan. Cek kembali passphrase atau koneksi internet Anda.</b>,
          success: <b>Dokumen berhasil ditandatangani</b>
        })
        .then(() => {
          // setIsSaved(true);
          setSigner({ ...signer, passphrase: '' });
          getLayanan();
          setIsSubmitting(false);
        })
        .catch((error) => {
          setIsSubmitting(false);
          setSigner({ ...signer, passphrase: '' });
          errorLogger(error);
        });
    }
  };

  const signUpload = async () => {
    setIsSubmitting(true);

    const formData = new FormData();
    formData.append('file', attachment.file);
    formData.append('upload_type', 'document');

    if (decoded.selectedRequirement.type === 'data_permohonan') {
      const id = layanan?.attributes?.id_permohonan;
      // const origin = getBaseURL();
      // const linkQR = `${origin}/pdfscan?id=${id}`;
      formData.append('id_permohonan', id);
      // formData.append('link_qr', linkQR);
      formData.append('user_info', JSON.stringify(user));
      formData.append('type', layanan?.type);

      toast
        .promise(permohonanService.signUpload(formData), {
          loading: 'Mohon tunggu ...',
          error: <b>Maaf, terjadi kesalahan</b>,
          success: <b>Dokumen berhasil ditandatangani</b>
        })
        .then(() => {
          // setIsSaved(true);
          setSigner({ ...signer, passphrase: '' });
          getLayanan();
          setIsSubmitting(false);
        })
        .catch(() => {
          setIsSubmitting(false);
          setSigner({ ...signer, passphrase: '' });
        });
    }

    if (decoded.selectedRequirement.type === 'kategori_se') {
      const id = layanan?.attributes?.id_kategorisasi_se;
      // const origin = getBaseURL();
      // const linkQR = `${origin}/pdfscan?id=${id}`;
      formData.append('id_kategorisasi_se', id);
      // formData.append('link_qr', linkQR);
      formData.append('user_info', JSON.stringify(user));
      formData.append('type', 'Kategori Sistem Elektronik');

      toast
        .promise(kategoriseService.signUpload(formData), {
          loading: 'Mohon tunggu ...',
          error: <b>Maaf, terjadi kesalahan</b>,
          success: <b>Dokumen berhasil ditandatangani</b>
        })
        .then(() => {
          // setIsSaved(true);
          setSigner({ ...signer, passphrase: '' });
          getLayanan();
        })
        .catch(() => {
          setIsSubmitting(false);
          setSigner({ ...signer, passphrase: '' });
        });
    }

    if (decoded.selectedRequirement.type === 'feedback') {
      setIsSubmitting(false);
      const id = layanan?.attributes?.id_feedback;
      // const origin = getBaseURL();
      // const linkQR = `${origin}/pdfscan?id=${id}`;
      formData.append('id_feedback', id);
      // formData.append('link_qr', linkQR);
      formData.append('status', layanan?.meta?.feedback?.metadata?.answers?.status);
      formData.append('type', layanan?.type);
      formData.append('user_info', JSON.stringify(user));

      toast
        .promise(feedbackService.signUpload(formData), {
          loading: 'Mohon tunggu ...',
          error: <b>Maaf, terjadi kesalahan</b>,
          success: <b>Dokumen berhasil ditandatangani</b>
        })
        .then(() => {
          // setIsSaved(true);
          setSigner({ ...signer, passphrase: '' });
          getLayanan();
          setIsSubmitting(false);
        })
        .catch(() => {
          setIsSubmitting(false);
          setSigner({ ...signer, passphrase: '' });
        });
    }
  };

  return (
    <Box>
      {/* <Header user={user} /> */}
      <Container>
        <Stack direction="column" p={4} spacing={2}>
          <span />
          {!_.isEmpty(informations) && (
            <Stack
              direction="column"
              spacing={2}
              divider={<Divider orientation="horizontal" flexItem />}
            >
              <Informations
                id={id}
                token={token}
                attachment={attachment}
                setAttachment={setAttachment}
                signUpload={signUpload}
                layanan={layanan}
                informations={informations}
                signDocument={signDocument}
                setSigner={setSigner}
                signer={signer}
                decoded={decoded}
                setOpenPreview={setOpenPreview}
                isSubmitting={isSubmitting}
                user={user}
              />
              {!layanan?.meta?.[decoded.selectedRequirement.type]?.is_signed &&
                !layanan?.meta?.[decoded.selectedRequirement.type]?.document_path && (
                  <Stack direction="column" justifyContent="center" alignItems="center" spacing={2}>
                    <Stack direction="row" spacing={2}>
                      <FormControlLabel
                        control={
                          <Switch
                            checked={openPreview}
                            onChange={() => setOpenPreview(!openPreview)}
                            defaultChecked
                          />
                        }
                        label="Lihat Dokumen"
                      />
                    </Stack>

                    {openPreview && (
                      <Typography variant="body2" sx={{ fontStyle: 'italic' }}>
                        Dokumen di bawah ini merupakan preview dari formulir yang telah di-input
                        sebelumnya
                      </Typography>
                    )}

                    {openPreview &&
                      !_.isEmpty(informations) &&
                      !_.isEmpty(layanan) &&
                      !_.isEmpty(decoded) && (
                        <PDFViewer
                          height="800"
                          width="100%"
                          showToolbar="true"
                          filename={getTitle(decoded.selectedRequirement.attributes.question_id)}
                        >
                          <PDFDocument
                            informations={informations}
                            decoded={decoded}
                            layanan={layanan}
                          />
                        </PDFViewer>
                      )}
                  </Stack>
                )}
            </Stack>
          )}
        </Stack>
      </Container>
    </Box>
  );
}
//

Informations.propTypes = {
  layanan: PropTypes.object.isRequired,
  informations: PropTypes.any,
  signDocument: PropTypes.func.isRequired,
  setSigner: PropTypes.func.isRequired,
  signer: PropTypes.any,
  decoded: PropTypes.object.isRequired,
  isSubmitting: PropTypes.any
};

function Informations({
  layanan,
  informations,
  signDocument,
  setSigner,
  signer,
  decoded,
  setOpenPreview,
  isSubmitting,
  user,
  attachment,
  setAttachment,
  signUpload,
  id,
  token
}) {
  const Input = styled('input')({
    display: 'none'
  });
  const theme = useTheme();
  const navigate = useNavigate();
  const [submitting, setSubmitting] = React.useState(false);
  const [toggleUpdate, setToggleUpdate] = React.useState(false);
  const location = useLocation();
  const locationSplit = location.pathname.split('/');

  const updateField = (e, key) => {
    const { value } = e.target;
    setOpenPreview(false);
    setSigner({ ...signer, [key]: value });
  };

  let isSigned = false;

  if (
    layanan?.meta?.[decoded.selectedRequirement.type]?.is_signed &&
    layanan?.meta?.[decoded.selectedRequirement.type]?.document_path
  )
    isSigned = true;

  function onFileChange(event) {
    if (event.target.files[0].size > 500024 * 10) {
      return toast.error(
        'Maaf, file Anda melebihi batas 5MB, harap compress dokumen terlebih dahulu'
      );
    }

    setAttachment({
      ...attachment,
      file: event.target.files[0],
      filename: event.target.files[0].name
    });
  }

  const copyLink = async () => {
    const url = getBaseURL();
    const link = `${url}/pdf/share/${id}/${token}`;

    // save link to database here
    try {
      const body = {
        data: {
          id,
          attributes: {
            link,
            creator: user?.attributes?.id
          }
        }
      };
      const result = await shortlinkService.addShortLink(body);
      navigator.clipboard.writeText(`${url}/pdf/shortlink/${id}`);
      toast.success('URL telah di-copy, silakan bagikan ke penandatangan');
    } catch (error) {
      toast.error(error.message);
    }
  };

  return (
    <Stack direction="column" spacing={2}>
      {locationSplit[2] !== 'share' && (
        <Stack direction="row" alignItems="center" spacing={2} mb={6}>
          <Icon
            cursor="pointer"
            // onClick={() => navigate(-1, { replace: true })}
            onClick={() => navigate(`/dashboard/services/${id}`, { replace: true })}
            icon={arrowBackFilled}
            width={32}
            height={32}
            style={{ color: theme.palette.primary.main }}
          />

          <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
            Kembali ke halaman permohonan
          </Typography>
        </Stack>
      )}

      <Stack direction="column" spacing={2} alignItems="center">
        <Typography variant="h4" sx={{ textAlign: 'center' }}>
          {getTitle(decoded.selectedRequirement.attributes.question_id)}
        </Typography>

        {locationSplit[2] !== 'share' && !isSigned && (
          <Box>
            <Button onClick={copyLink} variant="outlined" startIcon={<Icon icon={shareOutline} />}>
              Bagikan Link
            </Button>
          </Box>
        )}
      </Stack>

      <Divider />

      <Stack
        direction={{ xs: 'column', sm: 'column', md: 'row' }}
        spacing={2}
        divider={<Divider orientation="vertical" flexItem />}
      >
        {console.log('data', signer.signername)}
        {!isSigned && (
          <>
            {decoded.modeTandaTangan === 'tte' && (
              <Stack direction="column" spacing={2} flex={5}>
                <Typography variant="h6">Masukkan informasi penandatangan</Typography>
                {signer.signername && <TextField disabled="true" value={signer.signername} />}
                {signer.nip && <TextField disabled="true" value={signer.nip} />}
                <TextField label="NIK" value={signer.nik} onChange={(e) => updateField(e, 'nik')} />
                <TextField
                  type="password"
                  label="Passphrase TTE"
                  value={signer.passphrase}
                  onChange={(e) => updateField(e, 'passphrase')}
                />
                <LoadingButton
                  loading={isSubmitting}
                  variant="outlined"
                  onClick={() => signDocument()}
                >
                  Tanda Tangan
                </LoadingButton>
              </Stack>
            )}

            {decoded.modeTandaTangan === 'manual' && (
              <Stack direction="column" spacing={2} flex={5}>
                <Typography variant="h6">Upload Dokumen</Typography>
                <Typography variant="body2">
                  Silakan pilih dan upload dokumen yang telah ditandatangani
                </Typography>
                <label htmlFor="uploader">
                  <>{/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}</>
                  <Input
                    accept="application/pdf"
                    id="uploader"
                    multiple
                    type="file"
                    onChange={(e) => onFileChange(e)}
                  />
                  <Button
                    component="span"
                    fullWidth
                    variant="outlined"
                    startIcon={<Icon icon={folderAddFill} />}
                    sx={{
                      color: theme.palette.warning.dark,
                      borderColor: theme.palette.warning.dark
                    }}
                  >
                    Pilih file
                  </Button>
                </label>

                {attachment.file && (
                  <>
                    <Typography variant="body2" sx={{ fontStyle: 'italic' }}>
                      {attachment.filename}
                    </Typography>
                    <LoadingButton
                      loading={submitting}
                      onClick={signUpload}
                      variant="outlined"
                      startIcon={<Icon icon={uploadFill} />}
                    >
                      Upload file
                    </LoadingButton>
                  </>
                )}
              </Stack>
            )}
          </>
        )}

        <Stack direction="column" spacing={2} flex={7}>
          {isSigned ? (
            <>
              <Typography variant="h6">Informasi</Typography>
              <Typography variant="body2">
                Dokumen telah berhasil ditandatangani, dokumen Anda akan diverifikasi oleh tim
                Peladen.
              </Typography>
            </>
          ) : (
            <>
              <Typography variant="h6">Informasi</Typography>
              {decoded.modeTandaTangan === 'tte' && (
                <Typography variant="body2">
                  Anda memilih tanda tangan menggunakan TTE (Tanda Tangan Elektronik). Silakan
                  periksa terlebih dahulu form permohonan di bawah ini, kemudian masukkan NIK &
                  Passphrase TTE untuk melakukan proses tanda tangan secara elektronik.
                </Typography>
              )}

              {decoded.modeTandaTangan === 'manual' && (
                <Typography variant="body2">
                  Anda memilih tanda tangan manual (tanpa Tanda Tangan Elektronik). Silakan periksa
                  terlebih dahulu dokumen di bawah ini, kemudian download dan upload kembali dokumen
                  yang telah ditandatangani.
                </Typography>
              )}
            </>
          )}

          <Typography variant="body2" style={{ fontWeight: 'bold' }}>
            Status Tanda Tangan
          </Typography>
          <Stack direction="row" pl={2} spacing={2} alignItems="center">
            <Icon
              icon={isSigned ? checkmarkCircleFill : closeCircleFill}
              width={32}
              height={32}
              color={isSigned ? theme.palette.primary.main : theme.palette.error.main}
            />
            <Typography variant="body2">
              {isSigned ? 'Sudah ditandatangani' : 'Belum ditandatangani'}{' '}
            </Typography>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
}

// Font.register({
//   family: 'BOOKOS',
//   src: '/fonts/BOOKOS.TTF'
// });

Font.register({
  family: 'Bookos',
  format: 'truetype',
  fonts: [
    { src: BookosRegular, fontWeight: 'normal' },
    { src: BookosItalic, fontStyle: 'italic' },
    { src: BookosBold, fontWeight: 'bold' },
    { src: BookosBolditalic, fontWeight: 'bold', fontStyle: 'italic' }
  ]
});

PDFDocument.propTypes = {
  layanan: PropTypes.object.isRequired,
  informations: PropTypes.any,
  decoded: PropTypes.object.isRequired
};

function PDFDocument({ layanan, informations, decoded, preview = true }) {
  const ROWHEIGHT = 90;
  const PADDINGTEXT = 4;
  const FONTSIZE = 12;
  const SUBFONTSIZE = 10;
  const SUBSUBFONTSIZE = 6.5;
  const BORDERCOLOR = '#454F5B';

  const now = moment.tz('Asia/Jakarta');

  function Header() {
    return (
      <View>
        <View
          fixed
          style={{
            flexDirection: 'row',
            alignItems: 'center',
            border: 1,
            borderWidth: 1,
            marginBottom: 16,
            width: '100%',
            borderColor: BORDERCOLOR
          }}
        >
          <View
            style={{
              borderRight: 1,
              height: ROWHEIGHT,
              alignItems: 'center',
              flexDirection: 'row',
              borderColor: BORDERCOLOR
            }}
          >
            <Image src="/static/logo.png" style={{ padding: 4 }} />
          </View>
          <View
            style={{
              borderRight: 1,
              height: ROWHEIGHT,
              alignItems: 'center',
              flexDirection: 'row',
              width: 200,
              borderColor: BORDERCOLOR
            }}
          >
            <Text
              style={{
                flex: 1,
                textAlign: 'center',
                fontSize: FONTSIZE,
                padding: 8,
                maxHeight: 100,
                fontFamily: 'Bookos',
                fontWeight: 'bold',
                color: BORDERCOLOR
              }}
            >
              {getTitle(decoded.selectedRequirement.attributes.question_id)}
            </Text>
          </View>
          <View
            style={{
              height: ROWHEIGHT,
              width: 60,
              flexDirection: 'column',
              justifyContent: 'center',
              borderRight: 1,
              borderColor: BORDERCOLOR
            }}
          >
            <View
              style={{
                borderBottom: 1,
                height: ROWHEIGHT / 3,
                justifyContent: 'center',
                borderColor: BORDERCOLOR
              }}
            >
              <Text
                style={{
                  fontSize: SUBFONTSIZE,
                  padding: PADDINGTEXT,
                  fontFamily: 'Bookos',
                  fontWeight: 'normal'
                }}
              >
                ID
              </Text>
            </View>
            <View
              style={{
                borderBottom: 1,
                height: ROWHEIGHT / 3,
                justifyContent: 'center',
                borderColor: BORDERCOLOR
              }}
            >
              <Text
                style={{
                  fontSize: SUBFONTSIZE,
                  padding: PADDINGTEXT,
                  fontFamily: 'Bookos',
                  fontWeight: 'normal'
                }}
              >
                Tanggal
              </Text>
            </View>
            <View style={{ height: ROWHEIGHT / 3, justifyContent: 'center' }}>
              <Text
                style={{
                  fontSize: SUBFONTSIZE,
                  padding: PADDINGTEXT,
                  fontFamily: 'Bookos',
                  fontWeight: 'normal'
                }}
              >
                Halaman
              </Text>
            </View>
          </View>
          <View
            style={{
              height: ROWHEIGHT,
              flexDirection: 'column',
              justifyContent: 'center',
              width: 160
            }}
          >
            <View
              style={{
                borderBottom: 1,
                height: ROWHEIGHT / 3,
                justifyContent: 'center',
                borderColor: BORDERCOLOR
              }}
            >
              <Text
                style={{
                  fontSize: SUBSUBFONTSIZE,
                  padding: PADDINGTEXT,
                  fontFamily: 'Bookos',
                  fontWeight: 'normal'
                }}
              >
                {decoded.selectedRequirement.type === 'data_permohonan' &&
                  layanan?.meta?.data_permohonan?.id}
                {decoded.selectedRequirement.type === 'kategori_se' &&
                  layanan?.meta?.kategori_se?.id}
                {decoded.selectedRequirement.type === 'feedback' && layanan?.meta?.feedback?.id}
              </Text>
            </View>
            <View
              style={{
                borderBottom: 1,
                height: ROWHEIGHT / 3,
                justifyContent: 'center',
                borderColor: BORDERCOLOR
              }}
            >
              <Text
                style={{
                  fontSize: SUBFONTSIZE,
                  padding: PADDINGTEXT,
                  fontFamily: 'Bookos',
                  fontWeight: 'normal'
                }}
              >
                {moment.tz(now, 'Asia/Jakarta').format('DD-MM-YYYY')}
              </Text>
            </View>
            <View style={{ height: ROWHEIGHT / 3, justifyContent: 'center' }}>
              <Text
                style={{
                  fontSize: SUBFONTSIZE,
                  padding: PADDINGTEXT,
                  fontFamily: 'Bookos',
                  fontWeight: 'normal'
                }}
                render={({ pageNumber, totalPages }) => `${pageNumber} / ${totalPages}`}
                fixed
              />
            </View>
          </View>
        </View>
      </View>
    );
  }

  function BodyPermohonan({ informations }) {
    const BORDERCOLOR = '#454F5B';
    return (
      <View
        style={{
          ...styles.section,
          borderTop: 1,
          borderLeft: 1,
          borderRight: 1,
          borderColor: BORDERCOLOR
        }}
      >
        {informations.map((item, index) => (
          <View
            style={{
              flexDirection: 'row',
              alignItems: 'center',
              flexWrap: 'wrap',
              borderBottom: 1,
              minHeight: 25,
              borderColor: BORDERCOLOR
            }}
          >
            <View
              style={{
                padding: 2,
                minWidth: '35%',
                maxHeight: 150,
                minHeight: 25,
                justifyContent: 'center',
                borderColor: BORDERCOLOR
              }}
            >
              <Text
                style={{
                  ...styles.textRegular,
                  width: '30%',
                  fontFamily: 'Bookos',
                  fontWeight: 'normal',
                  paddingLeft: 2,
                  maxLines: 2,
                  textOverflow: 'ellipsis'
                }}
              >
                {item.label}
              </Text>
            </View>
            <View
              style={{
                padding: 2,
                maxHeight: 150,
                minHeight: 25,
                justifyContent: 'center',
                minWidth: '65%',
                borderLeft: 1
              }}
            >
              <Text
                style={{
                  ...styles.textRegular,
                  width: '65%',
                  fontFamily: 'Bookos',
                  fontWeight: 'normal',
                  paddingLeft: 2
                }}
              >
                {item.answer}
              </Text>
            </View>
          </View>
        ))}
      </View>
    );
  }

  function BodyKategorisasiSE({ informations, layanan }) {
    const BORDERCOLOR = '#00bfa6';
    function Circle({ active }) {
      return (
        <View
          style={{
            width: 10,
            height: 10,
            backgroundColor: active === 'true' ? '#00bfa6' : '#F9FAFB',
            borderRadius: 5,
            borderColor: BORDERCOLOR,
            border: 1
          }}
        />
      );
    }

    return (
      <View>
        <View style={{ paddingBottom: 10 }}>
          <Text style={styles.textRegular}>Kategorisasi Sistem Elektronik</Text>
        </View>
        <View style={{ paddingBottom: 10, flexDirection: 'column' }}>
          <View style={{ flexDirection: 'row' }}>
            <View style={{ flex: 4 }}>
              <Text style={styles.textRegular}>Nama Sistem Elektronik</Text>
            </View>
            <View style={{ flex: 8 }}>
              <Text style={styles.textBold}>
                : {layanan?.meta?.data_permohonan?.metadata.answers?.nama_sistem_elektronik}
              </Text>
            </View>
          </View>
          <View style={{ flexDirection: 'row' }}>
            <View style={{ flex: 4 }}>
              <Text style={styles.textRegular}>Total Nilai</Text>
            </View>
            <View style={{ flex: 8 }}>
              <Text style={styles.textBold}>
                : {layanan?.meta?.kategori_se?.metadata.scores?.level}
              </Text>
            </View>
          </View>
          <View style={{ flexDirection: 'row' }}>
            <View style={{ flex: 4 }}>
              <Text style={styles.textRegular}>Kategori Sistem Elektronik</Text>
            </View>
            <View style={{ flex: 8 }}>
              <Text style={styles.textBold}>
                : {sentenceCase(layanan?.meta?.kategori_se?.metadata.scores?.category || '-')}
              </Text>
            </View>
          </View>
        </View>
        <View>
          {!_.isEmpty(informations) &&
            informations?.map((item, index) => (
              <View style={{ flexDirection: 'row' }}>
                <View style={{ paddingRight: 4 }} break>
                  <Text style={{ ...styles.textRegular, width: 16, textAlign: 'right' }}>
                    {index + 1}.
                  </Text>
                </View>
                <View style={{ flexDirection: 'column' }}>
                  <View style={{ paddingBottom: 4 }}>
                    <Text style={styles.textRegular}>{item.label}</Text>
                  </View>
                  <View>
                    {!_.isEmpty(item) &&
                      item?.options?.map((option, optionIndex) => (
                        <View
                          style={{ flexDirection: 'row', paddingRight: 4, alignItems: 'center' }}
                        >
                          <View style={{ padding: 4 }}>
                            <Circle active={option.id === item.answer ? 'true' : 'false'} />
                          </View>
                          <View>
                            <Text style={styles.textRegular}>{option.label}</Text>
                          </View>
                        </View>
                      ))}
                  </View>
                  {!_.isEmpty(item?.data_dukung) && item?.data_dukung && (
                    <View
                      style={{
                        border: 1,
                        borderRadius: 4,
                        padding: 4,
                        margin: 4,
                        borderColor: '#919EAB'
                      }}
                    >
                      <Text style={{ ...styles.textRegular, paddingVertical: 4 }}>
                        Data dukung: {item?.data_dukung}
                      </Text>
                    </View>
                  )}
                </View>
              </View>
            ))}
        </View>
      </View>
    );
  }

  function BodyFeedback({ informations }) {
    const BORDERCOLOR = '#454F5B';
    const getStatusText = (item) => {
      let status = 'Undefined';
      if (item.answer === 'approved') status = 'Disetujui';
      if (item.answer === 'semi_approved') status = 'Disetujui dengan catatan';
      if (item.answer === 'rejected') status = 'Ditolak';
      if (item.answer === 'pending') status = 'Pending';

      return status;
    };

    const getValue = (item) => {
      if (item.id === 'tanggal_rekomendasi') {
        moment.locale('id');
        return moment_(item.answer).format('DD MMMM YYYY');
      }
      if (item.id !== 'status') return item.answer;
      if (item.id === 'status') return getStatusText(item);
    };
    return (
      <View>
        <View style={{ margin: 8 }}>
          <Text
            style={{
              ...styles.textTitle,
              fontFamily: 'Bookos',
              textAlign: 'center'
            }}
          >
            Surat Rekomendasi
          </Text>
        </View>
        {informations.map((item, index) => (
          <View style={{ margin: 8 }}>
            {Array.isArray(item.answer) ? (
              <View>
                <View>
                  <Text
                    style={{
                      ...styles.textBold,
                      fontFamily: 'Bookos'
                    }}
                  >
                    {item.label}
                  </Text>
                </View>
                {item.answer?.map((answerItem, answerIndex) => (
                  <View style={{ marginVertical: 4, flexDirection: 'row' }}>
                    <Text
                      style={{
                        ...styles.textRegular,
                        fontFamily: 'Bookos',
                        fontWeight: 'normal',
                        marginRight: 4,
                        textAlign: 'justify'
                      }}
                    >
                      {answerIndex + 1}.
                    </Text>
                    <Text
                      style={{
                        ...styles.textRegular,
                        fontFamily: 'Bookos',
                        fontWeight: 'normal',
                        textAlign: 'justify'
                      }}
                    >
                      {answerItem.value}
                    </Text>
                  </View>
                ))}
              </View>
            ) : (
              <View>
                <View>
                  <Text
                    style={{
                      ...styles.textBold,
                      fontFamily: 'Bookos'
                    }}
                  >
                    {item.label}
                  </Text>
                </View>
                <View>
                  <Text
                    style={{
                      ...styles.textRegular,
                      fontFamily: 'Bookos',
                      fontWeight: 'normal'
                    }}
                  >
                    {getValue(item)}
                  </Text>
                </View>
              </View>
            )}
          </View>
        ))}
      </View>
    );
  }

  function PenandaTangan({ informations, decoded, layanan }) {
    function Approver({ informations, decoded, layanan }) {
      return (
        <View
          style={{
            width: '50%',
            paddingTop: 10,
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <View
            style={{
              height: 50,
              alignItems: 'center',
              paddingBottom: 10,
              flexDirection: 'column',
              justifyContent: 'flex-end'
            }}
          >
            {!['rekomendasi', 'feedback'].includes(
              decoded.selectedRequirement.attributes.question_id
            ) && (
              <Text
                style={{
                  fontSize: 9,
                  fontFamily: 'Bookos',
                  fontWeight: 'normal',
                  textAlign: 'center'
                }}
              >
                Mengetahui
              </Text>
            )}

            <Text
              style={{
                fontSize: 9,
                fontFamily: 'Bookos',
                fontWeight: 'normal',
                textAlign: 'center'
              }}
            >
              {/* {
                layanan?.meta?.data_permohonan?.JenisPermohonan?.metadata?.requirements[
                  parseInt(decoded.id_requirement, 10) - 1 < 0
                    ? 0
                    : parseInt(decoded.id_requirement, 10) - 1
                ]?.meta?.approver[0]?.attributes?.label
              } */}
              {
                layanan?.meta?.data_permohonan?.JenisPermohonan?.metadata?.requirements[
                  indexFinder(
                    layanan?.meta?.data_permohonan?.JenisPermohonan?.metadata?.requirements,
                    decoded.id_requirement,
                    'id'
                  )
                ]?.meta?.approver[0]?.attributes?.label
              }
            </Text>
          </View>
          {preview ? (
            <View style={{ paddingBottom: 5 }}>
              {decoded.modeTandaTangan === 'tte' ? (
                <Image
                  allowDangerousPaths
                  src="https://peladen.jogjaprov.go.id/static/qr_draft.png"
                  style={{ width: 75, height: 75 }}
                />
              ) : (
                <View style={{ width: 75, height: 75 }} />
              )}
            </View>
          ) : (
            <View style={{ paddingBottom: 5 }}>
              {/* decoded.modeTandaTangan === 'tte' disable remove qrcode */}
              {decoded.modeTandaTangan === 'tte' ||
              !['feedback', 'rekomendasi'].includes(
                decoded.selectedRequirement.attributes.question_id
              ) ? (
                <Image
                  allowDangerousPaths
                  src={`${getAPIURL()}/qrcodes?id=${
                    layanan?.meta?.[
                      decoded.selectedRequirement.type
                    ]?.metadata?.qr_code_path?.split('/')[5]
                  }&year=${
                    layanan?.meta?.[
                      decoded.selectedRequirement.type
                    ]?.metadata?.qr_code_path?.split('/')[3]
                  }&month=${
                    layanan?.meta?.[
                      decoded.selectedRequirement.type
                    ]?.metadata?.qr_code_path?.split('/')[4]
                  }`}
                  style={{ width: 75, height: 75 }}
                />
              ) : (
                <View style={{ width: 75, height: 75 }} />
              )}
            </View>
          )}

          <Text
            style={{
              fontSize: 9,
              fontFamily: 'Bookos',
              fontWeight: 'normal',
              textDecoration: 'underline',
              textAlign: 'center'
            }}
          >
            {
              layanan?.meta?.data_permohonan?.JenisPermohonan?.metadata?.requirements[
                indexFinder(
                  layanan?.meta?.data_permohonan?.JenisPermohonan?.metadata?.requirements,
                  decoded.id_requirement,
                  'id'
                )
              ]?.meta?.approver[0]?.attributes?.name
            }
          </Text>
          <Text
            style={{
              fontSize: 9,
              fontFamily: 'Bookos',
              fontWeight: 'normal',
              textAlign: 'center'
            }}
          >
            NIP.{' '}
            {/* {
              layanan?.meta?.data_permohonan?.JenisPermohonan?.metadata?.requirements[
                decoded.id_requirement - 1 < 0 ? 0 : decoded.id_requirement - 1
              ]?.meta?.approver[0]?.attributes?.nip
            } */}
            {
              layanan?.meta?.data_permohonan?.JenisPermohonan?.metadata?.requirements[
                indexFinder(
                  layanan?.meta?.data_permohonan?.JenisPermohonan?.metadata?.requirements,
                  decoded.id_requirement,
                  'id'
                )
              ]?.meta?.approver[0]?.attributes?.nip
            }
          </Text>
        </View>
      );
    }

    function Requestor({ informations, decoded, layanan }) {
      return (
        <View
          style={{
            width: '50%',
            paddingTop: 10,
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <View
            style={{
              height: 50,
              textAlign: 'center',
              paddingBottom: 10,
              flexDirection: 'column',
              justifyContent: 'flex-end'
            }}
          >
            <Text
              style={{
                fontSize: 9,
                fontFamily: 'Bookos',
                fontWeight: 'normal',
                textAlign: 'center'
              }}
            >
              Kepala {layanan?.meta?.requestor?.name}
            </Text>
          </View>
          {preview ? (
            <View style={{ paddingBottom: 5 }}>
              {decoded.modeTandaTangan === 'tte' ? (
                <Image
                  allowDangerousPaths
                  src="https://peladen.jogjaprov.go.id/static/qr_draft.png"
                  style={{ width: 75, height: 75 }}
                />
              ) : (
                <View style={{ width: 75, height: 75 }} />
              )}
            </View>
          ) : (
            <View style={{ paddingBottom: 5 }}>
              {decoded.modeTandaTangan === 'tte' ? (
                <Image
                  allowDangerousPaths
                  src={`${getAPIURL()}/qrcodes?id=${
                    layanan?.meta?.[
                      decoded.selectedRequirement.type
                    ]?.metadata?.qr_code_path?.split('/')[5]
                  }&year=${
                    layanan?.meta?.[
                      decoded.selectedRequirement.type
                    ]?.metadata?.qr_code_path?.split('/')[3]
                  }&month=${
                    layanan?.meta?.[
                      decoded.selectedRequirement.type
                    ]?.metadata?.qr_code_path?.split('/')[4]
                  }`}
                  style={{ width: 75, height: 75 }}
                />
              ) : (
                <View style={{ width: 75, height: 75 }} />
              )}
            </View>
          )}

          <Text
            style={{
              fontSize: 9,
              fontFamily: 'Bookos',
              fontWeight: 'normal',
              textDecoration: 'underline',
              textAlign: 'center'
            }}
          >
            {layanan?.meta?.data_permohonan?.metadata?.answers?.nama_kepala_dinas ||
              layanan?.meta?.kategori_se?.metadata?.answers?.nama_kepala_dinas ||
              '-'}
          </Text>
          <Text
            style={{
              fontSize: 9,
              fontFamily: 'Bookos',
              fontWeight: 'normal',
              textAlign: 'center'
            }}
          >
            NIP. {layanan?.meta?.data_permohonan?.metadata?.answers?.nip_kepala_dinas}
          </Text>
        </View>
      );
    }
    return (
      <View
        break
        style={{
          paddingTop: 10,
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        {/* {['data_permohonan'].includes(decoded.selectedRequirement.type) &&
        decoded.selectedRequirement.attributes.question_id !== 'rekomendasi' ? (
          <Approver informations={informations} decoded={decoded} layanan={layanan} />
        ) : (
          <View
            style={{
              width: '50%',
              paddingTop: 10,
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          />
        )} */}
        <View
          style={{
            width: '50%',
            paddingTop: 10,
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        />

        {['feedback'].includes(decoded.selectedRequirement.type) ? (
          <Approver informations={informations} decoded={decoded} layanan={layanan} />
        ) : (
          <Requestor informations={informations} decoded={decoded} layanan={layanan} />
        )}
      </View>
    );
  }

  function PDFGenerator({ informations, layanan, decoded, preview }) {
    return (
      <View>
        <Watermark />
        <View>
          {['tte'].includes(decoded.selectedRequirement?.attributes?.question_id) && (
            <PDFRendererForTTE
              BodyPermohonan={<BodyPermohonan informations={informations} />}
              Header={<Header />}
              informations={informations}
              layanan={layanan}
              decoded={decoded}
              preview={preview}
            />
          )}

          {['aduan'].includes(decoded.selectedRequirement?.attributes?.question_id) && (
            <PDFRendererForAduan
              BodyPermohonan={<BodyPermohonan informations={informations} />}
              Header={<Header />}
              informations={informations}
              layanan={layanan}
              decoded={decoded}
              preview={preview}
            />
          )}

          {['videotron'].includes(decoded.selectedRequirement?.attributes?.question_id) && (
            <PDFRendererForVideotron
              BodyPermohonan={<BodyPermohonan informations={informations} />}
              Header={<Header />}
              informations={informations}
              layanan={layanan}
              decoded={decoded}
              preview={preview}
            />
          )}

          {['vpn'].includes(decoded.selectedRequirement?.attributes?.question_id) && (
            <PDFRendererForVPN
              BodyPermohonan={<BodyPermohonan informations={informations} />}
              Header={<Header />}
              informations={informations}
              layanan={layanan}
              decoded={decoded}
              preview={preview}
            />
          )}

          {['backup'].includes(decoded.selectedRequirement?.attributes?.question_id) && (
            <PDFRendererForBackup
              BodyPermohonan={<BodyPermohonan informations={informations} />}
              Header={<Header />}
              informations={informations}
              layanan={layanan}
              decoded={decoded}
              preview={preview}
            />
          )}

          {['email'].includes(decoded.selectedRequirement?.attributes?.question_id) && (
            <PDFRendererForEmail
              BodyPermohonan={<BodyPermohonan informations={informations} />}
              Header={<Header />}
              informations={informations}
              layanan={layanan}
              decoded={decoded}
              preview={preview}
            />
          )}

          {['general'].includes(decoded.selectedRequirement?.attributes?.format) && (
            <PDFRendererForGeneral
              BodyPermohonan={<BodyPermohonan informations={informations} />}
              Header={<Header />}
              informations={informations}
              layanan={layanan}
              decoded={decoded}
              preview={preview}
            />
          )}

          {/* {console.log('coba ', decoded.selectedRequirement?.attributes?.question_id)} */}
          {![
            'tte',
            'aduan',
            'videotron',
            'splp',
            'cloud',
            'email',
            'backup',
            'vpn',
            'web'
          ].includes(decoded.selectedRequirement?.attributes?.question_id) && (
            <View>
              {!['feedback'].includes(decoded.selectedRequirement.type) && <Header />}
              {decoded.selectedRequirement.type === 'data_permohonan' &&
                !_.isEmpty(informations) && <BodyPermohonan informations={informations} />}
              {decoded.selectedRequirement.type === 'kategori_se' && !_.isEmpty(informations) && (
                <BodyKategorisasiSE informations={informations} layanan={layanan} />
              )}
              {decoded.selectedRequirement.type === 'feedback' && !_.isEmpty(informations) && (
                <BodyFeedback informations={informations} />
              )}

              <PenandaTangan informations={informations} layanan={layanan} decoded={decoded} />
            </View>
          )}
        </View>
      </View>
    );
  }

  function getPageStyle() {
    let style = styles.page;
    if (['feedback'].includes(decoded.selectedRequirement.type)) {
      style = decoded.modeTandaTangan === 'manual' ? styles.pageWaterMarked : styles.page;
    } else {
      style =
        decoded.modeTandaTangan === 'manual'
          ? styles.pageWithPaddingTopWaterMarked
          : styles.pageWithPaddingTop;
    }
    return style;
  }

  const Watermark = () => {
    const { modeTandaTangan } = decoded;
    return (
      <View>
        {modeTandaTangan === 'manual' && (
          <View style={styles.watermarked}>
            <Text
              style={{
                fontSize: 60,
                fontFamily: 'Bookos',
                fontWeight: 'normal',
                textAlign: 'center',
                opacity: '0.08'
              }}
            >
              PELADEN
            </Text>
          </View>
        )}
      </View>
    );
  };

  return (
    <Document
      title={getTitle(decoded.selectedRequirement.attributes.question_id)}
      author="Peladen Pemda DIY"
      creator="Peladen Pemda DIY"
    >
      <Page size="FOLIO" wrap style={getPageStyle()}>
        {['feedback'].includes(decoded.selectedRequirement.type) && (
          <View>
            <Image src="/static/kop/diskominfo_diy.png" style={{ padding: 4 }} />
          </View>
        )}
        {!_.isEmpty(informations) && !_.isEmpty(layanan) && !_.isEmpty(decoded) ? (
          <View style={{ paddingLeft: '3cm', paddingRight: '2cm' }}>
            <PDFGenerator
              informations={informations}
              decoded={decoded}
              layanan={layanan}
              preview={preview}
            />
          </View>
        ) : (
          <View>
            <Text>Failed loading pdf data</Text>
          </View>
        )}
      </Page>
    </Document>
  );
}
